import { getBranchNodeIds } from './branchVisibility';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const EVENT_KEYS = Object.freeze(['hidden', 'mindmapId', 'nodeId', 'type', 'v']);

export function parseNodeBranchModerationChangedEvent(payload, expectedMindmapId) {
  if (typeof payload !== 'string' || payload.length > 512) return null;
  try {
    const parsed = JSON.parse(payload);
    if (
      !parsed
      || typeof parsed !== 'object'
      || Array.isArray(parsed)
      || parsed.v !== 1
      || parsed.type !== 'node_branch_moderation.changed'
      || !EVENT_KEYS.every((key) => Object.hasOwn(parsed, key))
      || Object.keys(parsed).sort().join(',') !== EVENT_KEYS.join(',')
      || parsed.mindmapId !== expectedMindmapId
      || !UUID_PATTERN.test(parsed.mindmapId)
      || !UUID_PATTERN.test(parsed.nodeId)
      || typeof parsed.hidden !== 'boolean'
    ) return null;
    return Object.freeze({
      v: 1,
      type: 'node_branch_moderation.changed',
      mindmapId: parsed.mindmapId,
      nodeId: parsed.nodeId,
      hidden: parsed.hidden,
    });
  } catch {
    return null;
  }
}

export function deriveNodeBranchModerationProjection({
  nodes,
  relationships,
  branches,
  currentUserId,
  accessRole,
}) {
  const excludedNodeIds = new Set();
  const fadedNodeIds = new Set();
  const warningRootIds = new Set();
  const ownerView = accessRole === 'owner';

  (branches || []).forEach((branch) => {
    if (!branch?.nodeId) return;
    const branchNodeIds = getBranchNodeIds(branch.nodeId, relationships);
    const creatorView = Boolean(
      currentUserId && branch.creatorUserId === currentUserId
    );
    if (ownerView || creatorView) {
      branchNodeIds.forEach((nodeId) => fadedNodeIds.add(nodeId));
      warningRootIds.add(branch.nodeId);
    } else {
      branchNodeIds.forEach((nodeId) => excludedNodeIds.add(nodeId));
    }
  });

  const validNodeIds = new Set((nodes || []).map((node) => node?.id).filter(Boolean));
  return {
    excludedNodeIds: new Set([...excludedNodeIds].filter((id) => validNodeIds.has(id))),
    fadedNodeIds: new Set([...fadedNodeIds].filter((id) => validNodeIds.has(id))),
    warningRootIds: new Set([...warningRootIds].filter((id) => validNodeIds.has(id))),
  };
}

export function filterModeratedGraph(nodes, relationships, excludedNodeIds) {
  const excluded = excludedNodeIds || new Set();
  return {
    nodes: (nodes || []).filter((node) => !excluded.has(node.id)),
    relationships: (relationships || []).filter((relationship) => (
      !excluded.has(relationship.parentId) && !excluded.has(relationship.childId)
    )),
  };
}

